import { useCallback, useRef, useState } from 'react';
import type SwiperCore from 'swiper';
import type { SwiperRef } from 'swiper/react';

export const useSwiperNavigation = () => {
  const sliderRef = useRef<SwiperRef | null>(null);
  const [isEnd, setIsEnd] = useState<boolean>(false);
  const [isStart, setIsStart] = useState<boolean>(false);
  const [isInteracted, setIsInteracted] = useState<boolean>(false);

  const syncNavigationState = useCallback((swiper: SwiperCore) => {
    setIsEnd(swiper.isEnd);
    setIsStart(swiper.isBeginning);
  }, []);

  const handlePrev = useCallback(() => {
    sliderRef.current?.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    sliderRef.current?.swiper.slideNext();
  }, []);

  const handleInit = useCallback(
    (swiper: SwiperCore) => {
      syncNavigationState(swiper);
    },
    [syncNavigationState],
  );

  const handleSlideChange = useCallback(
    (swiper: SwiperCore) => {
      syncNavigationState(swiper);
      setIsInteracted(true);
    },
    [syncNavigationState],
  );

  return {
    sliderRef,
    isEnd,
    isStart,
    isInteracted,
    handlePrev,
    handleNext,
    handleInit,
    handleSlideChange,
  };
};

export default useSwiperNavigation;
